import { imagesConstants, authConstants } from '../constants';
import { MessagesActions, EventsActions } from './';
import { ImagesApi } from '../services';
import { ImagesCache, Img } from '../helper';
import Worker from '../helper/worker/downloadImages.worker'; // using webpack worker-loader
import saveAs from 'file-saver';

const {REACT_APP_API_BASE_URL} = process.env;

export class ImagesActions {
    static getAllImages(eventID) {
        return (dispatch) => {
            dispatch({type: imagesConstants.GET_ALL_IMAGES_REQUEST});

            ImagesApi.getAllImages(eventID)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: imagesConstants.GET_ALL_IMAGES_SUCCESS, payload: {[eventID]: res.data}});
                        return;
                    }

                    return dispatch({type: imagesConstants.GET_ALL_IMAGES_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: imagesConstants.GET_ALL_IMAGES_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה בטעינת התמונות'));
                })
        }
    }

    static updateImage (eventID, imageID, data) {
        return (dispatch) => {
            dispatch({type: imagesConstants.UPDATE_IMAGE_REQUEST, payload: {imageID: imageID}});

            ImagesApi.updateImage(eventID, imageID, data)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: imagesConstants.UPDATE_IMAGE_SUCCESS, payload: res.data});
                        dispatch(MessagesActions.pushSuccess('התמונה עודכנה בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('לא ניתן לעדכן את התמונה אנא נסו שנית'));
                    return dispatch({type: imagesConstants.UPDATE_IMAGE_FAILURE, payload: {imageID: imageID}});
                })
                .catch((err) => {
                    dispatch({type: imagesConstants.UPDATE_IMAGE_FAILURE, payload: {imageID: imageID}});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }

    static deleteImage (eventID, imageID) {
        return (dispatch) => {
            dispatch({type: imagesConstants.DELETE_IMAGE_REQUEST, payload: {imageID: imageID}});

            ImagesApi.deleteImage(eventID, imageID)
                .then((res) => {
                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch(EventsActions.getEventData(eventID)); // get updated event data (without this image)
                        dispatch({type: imagesConstants.DELETE_IMAGE_SUCCESS, payload: {eventID: eventID, _id: imageID}});
                        dispatch(MessagesActions.pushSuccess('התמונה נמחקה בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('מחיקת התמונה נכלשה אנא נסו שוב...'));
                    return dispatch({type: imagesConstants.DELETE_IMAGE_FAILURE, payload: {imageID: imageID}});
                })
                .catch((err) => {
                    dispatch({type: imagesConstants.DELETE_IMAGE_FAILURE, payload: {imageID: imageID}});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }

    static imageStream (eventID) {
        return (dispatch) => {
            const evtSource = ImagesApi.imagesStream(eventID);
            
            evtSource.on('newImage', (e) => {
                if(!e.data || e.origin !== REACT_APP_API_BASE_URL) return;

                const data = JSON.parse(e.data);
                dispatch({type: imagesConstants.NEW_IMAGE_FROM_STREAM, payload: data});
            });

            return evtSource;
        }
    }

    // TODO: dispatch download process message
    static downloadAllImages (event, images) {
        return (dispatch) => {
            if(!images || !event || images.length === 0) {
                return dispatch(MessagesActions.pushError('אין תמונות להורדה'));
            }
            
            if(!ImagesCache.support()) {
                return dispatch(MessagesActions.pushError('הדפדפן שלך לא תומך באפשרות זו'));
            }

            const {REACT_APP_EVENT_IMAGES_DOWNLOAD_CHUNK_SIZE} = process.env;
            dispatch({
                type: imagesConstants.DOWNLOAD_EVENT_IAMGES_REQUEST,
                payload: {
                    eventID: event._id,
                    chunks: Math.ceil(images.length / REACT_APP_EVENT_IMAGES_DOWNLOAD_CHUNK_SIZE)
                }
            })

            const thread = new Worker();
            thread.postMessage({action: "data", payload: {images: images, event: event}});

            thread.addEventListener('message', (e) => {
                const {action, payload} = e.data;

                if(action === 'blob') {
                    saveAs(payload.blob, `${event.name || event._id}${payload.count ? ` ${payload.count}`: ''}.zip`);
                    dispatch({type: imagesConstants.DOWNLOADED_EVENT_IAMGES_CHUNK});
                }

                if(action === 'finish') {
                    dispatch({type: imagesConstants.DOWNLOAD_EVENT_IMAGES_SUCCESS});
                }

                if(action === 'error') {
                    dispatch({type: imagesConstants.DOWNLOAD_EVENT_IMAGES_FAILURE});
                }
            });
        }
    }

    static downloadImage(image, base64) {
        return (dispatch) => {

            const donwload = () => {
                const blob = Img.base64ToBlob(base64);
                saveAs(blob, `${image._id}.${blob.type.substr(blob.type.indexOf('/')+1)}`);
            }

            const err = () => {
                return dispatch(MessagesActions.pushError('הדפדפן שלך לא תומך באפשרות זו'));
            }

            if(!base64) {
                const cache = new ImagesCache();
                if(!cache) return err();

                cache.get(image._id, image.url).then((e) => {
                    base64 = e.data;

                    donwload();
                }).catch(err);

            } else {
                donwload();
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/images.js